export default __webpack_public_path__ + "static/media/profile overview.c6c20166.png";